<!-- 开卡管理 -->
<template>
  <div class="basicStyle"> 
    <div class="bg_fff"> 
      <div class="querySearch">
        <div class="searchItem">
          <span>创建时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>开卡时间</span>
          <el-date-picker
            v-model="cardTime"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="cardData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>开卡手机号码</span>
          <el-input
            v-model="queryInfo.card_mobile"
            clearable
            size="small"
            placeholder="请输入手机号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>开卡状态</span>
          <el-select
            v-model="queryInfo.card_status"
            filterable
            placeholder="请选择开卡状态"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in cardStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>商品</span>
          <el-select
            v-model="queryInfo.tob_good_type"
            filterable
            placeholder="请选择开卡状态"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in tobGoodTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="searchItem">
          <span>商品名称</span>
          <el-input
            v-model="queryInfo.good_name"
            clearable
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>卡号</span>
          <el-input
            v-model="queryInfo.number"
            clearable
            size="small"
            placeholder="请输入卡号"
          ></el-input>
        </div>

        <div class="searchItem">
          <span>订单号</span>
          <el-input
            v-model="queryInfo.order_no"
            clearable
            size="small"
            placeholder="请输入订单号"
          ></el-input>
        </div>
        <div class="searchItem">
          <!-- <el-button type="primary" size="small" @click="queryTable('search')"
            >搜索</el-button
          >
          <el-button type="warning" size="small" @click="resetQuery"
            >重置</el-button
          > -->

          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>
        </div>
      </div>
      <div class="addInfo">
        <!-- <el-button type="success" size="small" @click="createCard"
          >生成卡号、密码</el-button
        >
        <el-button type="danger" size="small" @click="downloadExcel"
          >导出</el-button
        > -->
        <MyButton
          value="生成卡号、密码"
          size="medium"
          type="4"
          icon="el-icon-key"
          @click="createCard"
        ></MyButton>
        <MyButton
          value="导出"
          size="medium"
          type="1"
          @click="downloadExcel"
        ></MyButton>
        <MyButton value="使用说明" size="medium" type="5" @click="instructions">
        </MyButton>
      </div>
      <div>
        <div class="table" v-if="tableList && tableList.length > 0">
          <TableComponents :columns="columns" :tableData="tableList">
            <template slot="order_no" slot-scope="{ row }">
              <span class="operationItem" @click="orderDetail(row)">{{
                row.order_no
              }}</span>
            </template>
            <template slot="card_status" slot-scope="{ row }">
              {{ cardStatusMap.get(row.card_status) }}
            </template>
          </TableComponents>
          <div style="text-align: right; margin-top: 10px; margin-right: 50px">
            已开卡
            <span style="color: red">{{ card_total }}</span>
            个，成本价
            <span style="color: red">{{ cb_price_total }}</span>
          </div>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.page"
              :page-sizes="[10, 30, 50, 80]"
              :page-size="queryInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else>
          <el-empty
            :image-size="100"
            description="请点击左上方按钮生成卡号、密码"
          ></el-empty>
        </div>
      </div>
    </div> 

    <!-- 生成卡密（激活码）弹窗 -->
    <el-dialog
      title="生成卡密（激活码）"
      :visible.sync="cardShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="cardForm"
        :rules="rules"
        ref="cardInfo"
        label-width="100px"
      >
        <el-form-item label="选择商品：" prop="good_name">
          <div
            class="goodName"
            v-if="cardForm.good_name"
            @click="goodClick"
            style="background: #f4f4f5;
                  padding: 0 15px; 
                  width: 220px;   
                  background: rgb(244, 244, 245);
                  padding: 0px 15px;
                  width: 220px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;"
          >
            {{ cardForm.good_name }}

            <i class="el-icon-arrow-right"></i>
          </div>
          <div
            class="goodName"
            v-else
            style="color: #409eff; cursor: pointer;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;"
            @click="goodClick"
          >
            请选择商品
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-form-item>
        <el-form-item v-if="cardForm.good_id" label="激活码个数：" prop="name">
          <el-input-number
            v-model="cardForm.num"
            :min="0"
            @change="numChange"
            style="margin-right: 20px"
          ></el-input-number
          >个
        </el-form-item>
        <div v-if="cardForm.priceTotal > 0" style="text-align: right">
          费用总计
          <span style="color: red">
            {{ cardForm.cb_price }}X{{ cardForm.num }}={{ cardForm.priceTotal }}
          </span>
          <span v-if="card_pay_type_name" style="margin-left: 10px">{{
            card_pay_type_name
          }}</span>
        </div>
      </el-form>
      <div v-if="cardForm.priceTotal > 0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser()" :loading="addLoading"
          >提交并支付</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="请选择需要开通的商品卡密"
      :visible.sync="goodVisible"
      class="formDialog"
      width="1200px"
    >
      <div class="querySearch">
        <div v-if="productTypeOptions.length > 1" style="margin-bottom: 10px">
          <el-select
            v-model="goodInfo.product_type_id"
            filterable
            placeholder="请选择产品"
            :clearable="true"
            size="mini"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in productTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-bottom: 10px">
          <el-radio-group
            v-model="goodInfo.tob_good_type_id"
            @change="tobGoodTypeChange"
          >
            <el-radio-button
              v-for="item in tob_good_type_list"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>

      <div>
        <!-- 视频课程 -->
        <TableComponents
          v-if="goodInfo.tob_good_type_id == 1"
          :columns="goodColumns1"
          :tableData="goodList"
        >
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewChoice(row)">选择</span>
          </template>
        </TableComponents>
        <!-- 会员 -->
        <TableComponents
          v-if="goodInfo.tob_good_type_id == 2"
          :columns="goodColumns2"
          :tableData="goodList"
        >
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewChoice(row)">选择</span>
          </template>
        </TableComponents>
        <!-- 套餐 -->
        <TableComponents
          v-if="goodInfo.tob_good_type_id == 3"
          :columns="goodColumns3"
          :tableData="goodList"
        >
          
          <template slot="course_list" slot-scope="{ row }"> 
            <div v-if="row.course_list&&row.course_list.length>0">
              <div>共{{row.course_list.length}}个课程</div>
              <div v-for="(item,index) in row.course_list" 
              style="
                  display: -webkit-box;
                  word-break: break-all;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: pre-line;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;"
              :key="index">{{item.name}}</div>
            </div> 
          </template>
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewChoice(row)">选择</span>
          </template>
        </TableComponents>

        <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="goodInfo.page"
            :page-sizes="[10, 30, 50, 80]"
            :page-size="goodInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
            style="margin-top:20px;text-align:center"
          >
          </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="deriveVisible"
      class="formDialog"
      width="900px"
    >
      <div style="text-align: center">
        {{ deriveForm.message }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deriveVisible = false" size="mini"
          >暂不导出</el-button
        >
        <el-button @click="atOnceDerive" size="mini">立即导出</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="instructionsVisible"
      class="formDialog"
      width="800px"
    >
      <div style="text-align: left; padding: 0 10px">
        <div class="instructionsBox">
          <div class="instructionsTitle">一、使用流程</div>
          <div >
            <img
              src="../../assets/new/tj_a15.png"
              alt=""
              style="width: 100%; height: auto; padding: 45px 0"
            />
          </div>
          <div class="instructionsTitle">二、使用卡密优势</div>
          <div class="instructionsCont">
            1、机构无需先导入学员再开通商品，直接发卡密给学员，可以节省很多时间； </br>
            2、学员通过激活链接或二维码输入卡号，密码激活商品后，即可在页面下载APP，使用默认密码（123456）登录学习，流程很简单；</br>
            3、学员用户信息和学习信息都会同步到机构的学员管理后台，机构可随时查看。
          </div>
          <div class="instructionsTitle">三、学员激活链接</div>
          <div class="instructionsCont">
            <div class="instructionsUrl">
              <span class="Url">{{active_url}}</span>
              <MyButton
                value="复制"
                size="medium" 
                type="3"
                @click="copyLink(active_url)"
              ></MyButton>
            </div>
          </div>
          <div class="instructionsTitle">三、激活二维码</div>
          <div style="width:260px;">
            <QrCode 
              :id="active_url"
              :pictureId="'picture_' + active_url"
              :newId="'new_' + active_url"
              :codeUrl="active_url"
              :title="active_url"
              :username="active_url"
              :password="active_url"
            /> 
          </div>
        </div>

        <!-- <iframe
          :src="instructionsExplain"
          :width="instructionsWidth"
          :height="instructionsHeight"
          frameborder="0"
          allowfullscreen
        /> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import TableComponents from "@/components/TableComponents.vue";
import { clearObj, deepClone, copyToClip } from "@/utils/index.js";
import qee from "qf-export-excel";
import QrCode from "@/components/QrCode.vue";
import MyButton from "@/components/MyButton.vue"; 
export default {
  name: "cardManage", //开卡管理
  components: {
    TableComponents,
    MyButton,
    QrCode
  },
  data() {
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        card_status: "",
        tob_good_type: "",
      },
      goodInfo: {
        product_type_id: 1,
        tob_good_type_id: 2,
        limit: 10,
        page: 1, 
      },
      total2:0,
      columns: [
        //列数据
        { label: "序号", prop: "id" },
        { label: "卡号", prop: "number" },
        { label: "密码", prop: "password" },
        { label: "商品类型", prop: "good_type_name" },
        { label: "商品名称", prop: "good_name" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "成本价", prop: "cb_price_arr" },
        { label: "订单编号", prop: "order_no", isMyself: true },
        { label: "创建时间", prop: "created_at" },
        { label: "开卡状态", prop: "card_status", isMyself: true },
        { label: "开卡时间", prop: "card_time" },
        { label: "开卡手机号码", prop: "card_mobile" },
        // { label: "操作", prop: "operation" },
      ],
      tableList: [],
      goodColumns: [
        { label: "商品名称", prop: "good_name" },
        { label: "商品类型", prop: "good_type_name" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "有效期", prop: "day" },
        { label: "成本价", prop: "cb_price_arr" },
        { label: "操作", prop: "operation", width: 180 },
      ], //商品数据
      goodColumns1: [
        { label: "课程名称", prop: "course_name" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "所属科目", prop: "subject_name" },
        { label: "视频总数", prop: "video_count" },
        { label: "视频总量/免费试听", prop: "video_free_count" },
        { label: "有效期", prop: "indate" },
        { label: "成本价", prop: "cb_price_arr" },
        { label: "正常销售价", prop: "price" },
        { label: "划线价", prop: "line_price" },
        // { label: "成本价配置类型", prop: "cost_price_config_type_name" },
        { label: "操作", prop: "operation", width: 180 },
      ],
      goodColumns2: [
        { label: "商品名称", prop: "good_name" },
        { label: "商品类型", prop: "good_type_name" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "有效期", prop: "day" },
        { label: "成本价", prop: "cb_price_arr" },
        { label: "操作", prop: "operation", width: 180 },
      ],
      goodColumns3: [
        { label: "套餐名称", prop: "package_name" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "包含课程数", prop: "course_list", isMyself: true  },
        { label: "有效期", prop: "indate" },
        { label: "成本价", prop: "cb_price_arr" },
        { label: "正常销售价", prop: "price" },
        { label: "划线价", prop: "line_price" },
        // { label: "成本价配置类型名", prop: "cost_price_config_type_name" },
        { label: "操作", prop: "operation", width: 180 },
      ],
      goodList: [], //商品列表
      timeFrame: [], //创建时间
      cardTime: [], //开卡时间
      cardStatusOptions: [
        //开卡状态
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "未开卡",
        },
        {
          value: 2,
          label: "已开卡",
        },
        {
          value: 3,
          label: "已失效",
        },
      ],
      tobGoodTypeOptions: [
        // 机构商品类型：1课程 2会员 3套餐
        {
          value: '',
          label: "全部",
        },
        {
          value: 1,
          label: "课程",
        },
        {
          value: 2,
          label: "会员",
        },
        {
          value: 3,
          label: "套餐",
        },
      ],
      // 新增编辑表单数据
      cardShow: false,
      goodVisible: false,
      deriveVisible: false,
      excelVisible: false,
      cardForm: {
        cb_price: 0,
        num: 0,
        priceTotal: 0,
      },
      rules: {
        //   name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      },
      card_total: "",
      cb_price_total: "", //成本价
      deriveForm: {},
      downExcelLoading: false, // 下载excel时，按钮的加载状态
      addLoading: false,
      tob_good_type_list: [],
      productTypeOptions: [
        // 1高职单招 2成考
        // {
        //   value: 1,
        //   label: "高职单招考试",
        //   key:'senioriup',
        // },
        // {
        //   value: 2,
        //   label: "成考",
        //   key:'adultscollege'
        // },
      ],
      instructionsVisible: false,
      instructionsWidth: "100%",
      instructionsHeight: "500px",
      instructionsExplain:
        "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongProductactivation&apptype=beikaotong",
      card_pay_type_name: "",
      active_url: "",
      senioriupShow:false,
      adultscollegeShow:false, 
    };
  },
  computed: {
    cardStatusMap() {
      return new Map(
        this.cardStatusOptions.map((item) => [item.value, item.label])
      );
    },
  },
  watch: {
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
    cardTime: {
      handler(_newVal) {
        if (!_newVal) {
          this.cardTime = [];
        }
      },
      deep: true,
    },
  },
  created() {
    this.homeList()
    this.queryTable();
  },
  methods: {
    async homeList() {
      const res = await commonApi.homeData({ app_keys: this.app_keys });
      if (res.code == 200) { 
        this.senioriupShow = false; 
        this.adultscollegeShow = false; 
        for(let i=0;i<res.data.menu.length;i++){
          if (res.data.menu[i].app_key == "senioriup") {
            this.senioriupShow = true;
          } 
          if (res.data.menu[i].app_key == "adultscollege") {
            this.adultscollegeShow = true;
          } 
        }

        // {
        //   value: 1,
        //   label: "高职单招考试",
        //   key:'senioriup',
        // },
        // {
        //   value: 2,
        //   label: "成考",
        //   key:'adultscollege'
        // },


        this.productTypeOptions = []
        if(this.senioriupShow){ 
          this.goodInfo.product_type_id = 1;
          this.productTypeOptions.push({
              value: 1,
              label: "高职单招考试",
              key:'senioriup',
          })
        }else{ 
          this.goodInfo.product_type_id = 2 
        }
        if(this.adultscollegeShow){  
          this.productTypeOptions.push({
              value: 2,
              label: "成考",
              key:'adultscollege'
          })
        } 

        
        if (this.goodInfo.product_type_id == 1) {
          this.goodInfo.tob_good_type_id = 2;
          this.tob_good_type_list = [{ id: 2, name: "会员" },{ id: 1, name: "视频课程" }];
        } else {
          this.goodInfo.tob_good_type_id = 3;
          this.tob_good_type_list = [ 
            { id: 3, name: "套餐" },
          ];
        }
      }
    },
    handleSizeChange2(e) {
      this.goodInfo.limit = e;
      this.getTobStudyCardGoods();
    },
    handleCurrentChange2(e) {
      this.goodInfo.page = e;
      this.getTobStudyCardGoods();
    },


    copyLink(e){ 
      copyToClip(e);
      this.$message.success("复制成功");
    },
    instructions() {
      // 使用说明
      this.instructionsVisible = true;
    },
    productTypeChange(e) {
      if (this.goodInfo.product_type_id == 1) {
        this.goodInfo.tob_good_type_id = 2;
        this.tob_good_type_list = [
          { id: 2, name: "会员" },
          { id: 1, name: "视频课程" },
        ];
      } else {
        this.goodInfo.tob_good_type_id = 3;
        this.tob_good_type_list = [
          { id: 3, name: "套餐" },
        ];
      }
      if (e) {
        this.goodInfo.page=1
        this.getTobStudyCardGoods();
      }
    },
    tobGoodTypeChange(e) {
      if (e) {
        this.goodInfo.page=1
        this.getTobStudyCardGoods();
      }
    },
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    async atOnceDerive() {
      // 立即导出
      var postData = {
        group_id: this.deriveForm.group_id,
        min_id: this.deriveForm.min_id,
        max_id: this.deriveForm.max_id,
      };
      const res = await commonApi.getTobStudyCardExport(postData);
      if (res.code == 200) {
        console.log("立即导出", res.data.url);
        window.open(res.data.url, "_blank");
        this.deriveVisible = false;
      }
    },
    addUser() {
      this.$confirm("是否确认提交", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          this.addLoading = true;
          if (!this.cardForm.good_id) {
            this.$message({
              message: "请选择商品！",
              type: "error",
            });
            return;
          }
          if (this.cardForm.num <= 0) {
            this.$message({
              message: "激活码个数大于0！",
              type: "error",
            });
            return;
          }

          var postData = {
            good_id: this.cardForm.good_id,
            num: this.cardForm.num,
            tob_good_type_id: this.goodInfo.tob_good_type_id,
          };
          commonApi.tobStudyCardAdd(postData).then((res) => {
            if(res.code==200){ 
              this.$message.success(res.message);
              this.addLoading = false;
              this.cardShow = false;
              this.deriveForm = res.data;
              this.deriveForm.message = res.message;
              this.deriveVisible = true;
              this.queryTable();
            }else{
              this.addLoading = false;
              this.cardShow = false;
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    numChange(e) {
      console.log("关联订单", e);
      // 激活码个数 
        this.cardForm.priceTotal =  (this.cardForm.cb_price*1000*this.cardForm.num)/1000;
    },
    async getTobStudyCardGoods() {
      // 开卡商品列表
      const res = await commonApi.getTobStudyCardGoods(this.goodInfo);
      if (res.code == 200) {
        console.log("开卡商品列表", res.data.list.data);

        res.data.list.data.forEach((item) => {
          item.cb_price_arr = item.cb_price + "元";
          // if(item.course_list&&item.course_list.length>0){
          //   console.log('course_list',item.course_list.length)
          //   item.course_list_arr = item.course_list.length;
          // }

        });

        this.goodList = res.data.list.data;
        this.total2 = res.data.list.total;
        

        this.card_pay_type_name = res.data.card_pay_type_name;

        // this.cardForm.good_name = this.goodList[0].good_name;
        // this.cardForm.good_id = this.goodList[0].good_id;
        // this.cardForm.cb_price = this.goodList[0].cb_price;
        if(this.goodList&&this.goodList.length>0){
          this.cardForm.tob_good_type_id = this.goodList[0].tob_good_type_id;
        }

        if (this.goodInfo.tob_good_type_id == 1) {
          this.cardForm.good_name = this.goodList[0].course_name;
          this.cardForm.good_id = this.goodList[0].course_id;
          this.cardForm.cb_price = Number(this.goodList[0].cb_price);
        } else if (this.goodInfo.tob_good_type_id == 2) {
          this.cardForm.good_name = this.goodList[0].good_name;
          this.cardForm.good_id = this.goodList[0].good_id;
          this.cardForm.cb_price = Number(this.goodList[0].cb_price);
        } else if (this.goodInfo.tob_good_type_id == 3) {
          this.cardForm.good_name = this.goodList[0].package_name;
          this.cardForm.good_id = this.goodList[0].package_id;
          this.cardForm.cb_price = Number(this.goodList[0].cb_price);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    orderDetail(e) {
      // 关联订单
      console.log("关联订单", e);
      this.$router.push({
        path: "/orderList",
        query: { order_no: e.order_no, order_type: e.order_type },
      });
    },
    viewChoice(e) {
      // 商品选择 1课程 2会员（默认） 3套餐
      console.log("商品选择", e);
      if (this.goodInfo.tob_good_type_id == 1) {
        this.cardForm.good_name = e.course_name;
        this.cardForm.good_id = e.course_id;
        this.cardForm.cb_price = Number(e.cb_price);
        this.goodVisible = false;
      } else if (this.goodInfo.tob_good_type_id == 2) {
        this.cardForm.good_name = e.good_name;
        this.cardForm.good_id = e.good_id;
        this.cardForm.cb_price = Number(e.cb_price);
        this.goodVisible = false;
      } else if (this.goodInfo.tob_good_type_id == 3) {
        this.cardForm.good_name = e.package_name;
        this.cardForm.good_id = e.package_id;
        this.cardForm.cb_price = Number(e.cb_price);
        this.goodVisible = false;
      }
      this.cardForm.num = 0
      this.cardForm.priceTotal =  (this.cardForm.cb_price*1000*this.cardForm.num)/1000;
    },
    goodClick() {
      // 商品选择弹窗
      this.goodInfo.page=1
      this.getTobStudyCardGoods();
      this.goodVisible = true;
    },
    createCard() {
      // 生成卡号、密码
      this.cardForm.cb_price = 0;
      this.cardForm.num = 0;
      this.cardForm.priceTotal = 0;
      this.cardForm.good_name = "";
      this.cardForm.good_id = "";

      this.goodInfo.page=1
      this.getTobStudyCardGoods();
      this.cardShow = true;
    },
    async downloadExcel() {
      // 导出

      // this.downExcelLoading = true;
      // var titleList = [
      //   { title: "序号", key: "id" },
      //   { title: "卡号", key: "number" },
      //   { title: "密码", key: "password" },
      //   { title: "商品类型", key: "good_type_name" },
      //   { title: "商品名称", key: "good_name" },
      //   { title: "所属考试", key: "subject_cate_name" },
      //   { title: "成本价", key: "cb_price_arr" },
      //   { title: "关联订单", key: "order_id" },
      //   { title: "创建时间", key: "created_at" },
      //   { title: "开卡状态", key: "card_status_arr" },
      //   { title: "开卡时间", key: "card_time" },
      //   { title: "开卡手机号码", key: "card_mobile" },
      // ];
      // let query = deepClone(this.queryInfo);
      // query.limit = 100000;
      // const res = await commonApi.getTobStudyCard(query);
      // if (res.code == 200) {
      //   this.excelVisible = true;
      //   res.data.list.data.forEach((item) => {
      //     item.cb_price_arr = item.cb_price + "元";
      //     item.card_status_arr = this.cardStatusMap.get(item.card_status);
      //   });
      //   this.excelTabelList = res.data.list.data;
      //   const randomStr = this.getCurrentDate() + this.generate();
      //   const fileName = randomStr;
      //   qee(titleList, this.excelTabelList, fileName);
      // } else {
      //   this.$message.error(res.message);
      // }

      this.$confirm("是否确认导出开卡数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = deepClone(this.queryInfo);
          query.limit = 100000;
          commonApi.getTobStudyCard(query).then((res) => {
            if (res.code === 200) {
              this.excelVisible = true;
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getCurrentDate() {
      let now = new Date();
      let year = ("000" + now.getFullYear()).slice(-4);
      let month = ("0" + (now.getMonth() + 1)).slice(-2);
      let day = ("0" + now.getDate()).slice(-2);
      return year.toString() + month.toString() + day.toString();
    },
    // 生成随机数
    generate() {
      let timeStr = new Date().valueOf() + "";
      let randomStr = Math.random() + "";
      return timeStr.slice(2, 8) + randomStr.slice(2, 8);
    },
    cardData(e) {
      // 开卡时间
      if (e) {
        this.queryInfo.card_start_date = e[0];
        this.queryInfo.card_end_date = e[1];
      } else {
        this.queryInfo.card_start_date = "";
        this.queryInfo.card_end_date = "";
      }
    },
    selectData(e) {
      // 创建时间
      if (e) {
        this.queryInfo.start_date = e[0];
        this.queryInfo.end_date = e[1];
      } else {
        this.queryInfo.start_date = "";
        this.queryInfo.end_date = "";
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await commonApi.getTobStudyCard(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        res.data.list.data.forEach((item) => {
          item.cb_price_arr = item.cb_price + "元";
        });
        this.tableList = res.data.list.data; 
 

        this.active_url = res.data.active_url 
        this.card_total = res.data.card_total;
        this.cb_price_total = res.data.cb_price_total;
      } else {
        this.$message.error(res.message);
      }
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.cardTime = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        card_status: "",
        tob_good_type: "",
        
      };
      this.queryTable();
    },
    // 分页
    handleSizeChange(e) {
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 10px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        // padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin-bottom: 10px;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .el-pagination__editor.el-input{
      width: 50px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }

  /deep/.tagDetail {
    padding: 10px;
    border: 1px solid #ddd;
    margin: 10px 0;
  }

  /deep/.el-input-number {
    width: 250px;
  }
  /deep/.goodName {
  }
  /deep/.instructionsBox {
    .instructionsTitle {
      font-size: 18px;
      font-weight: 600;
      color: #191b27;
    }
    .instructionsCont{
      font-size: 14px;  
      color: #465069;
      padding:22px 0 30px 30px;
      line-height: 160%; 
      
      .instructionsUrl{
        display:inline-block;
        padding:5px 6px;
        background: #F7F8FB;
        border-radius: 8px;
        .Url{
          margin-right:35px;
        }
      }
    }
  }
}


/deep/.itemTitle {
  display: none;
}
/deep/.itemAccounts {
  display: none;
}
/deep/.itemPassword {
  display: none;
}
/deep/.itemBtn .btn2{
  display: none; 
}
/deep/.experienceItem{
  border:none;
}
/deep/.itemBtn .btn1{
  width:200px;
} 
</style>
